'use strict';

const { bindGA, sendEventGA, getText, storePersistentData } = require('./util/analytics-util');
const { getProductData, hasClass, queryFirst, queryAll, setAdjustedSalesPrice } = require('lilly/domUtil');
const { VIEW_ITEM_LIST, LOYALTY_ENROLLMENT_EVENT_NAME, LOYALTY_PROGRAM_ACTION, LOYALTY_PROGRAM_SUCCESS_ENROLL, ENROLL_LOYALTY_CTA } = require('./util/constants');
const { getItemFromLocalStorage } = require('lilly/util');

const MORE_COLORS = 'more colors';
const PLP_FILTER_SELECT = 'plp filter select';
const PLP_MORE_RESULTS = 'plp more results';
const PLP_PAGINATION = 'plp pagination';
const PLP_SELECTIONS = 'plp selections';
const SHOP_BY_PRINT = 'shop by print';
const PLP_INTERACTION_FILTER = 'plp_interaction_filter';

/**
 * Analytics for PLPs / Search Results
 */
function initEvents() {
    const { utag_data: uData = {} } = window;
    const { body } = document;

    const categoryEl = document.getElementById('categoryType');
    const pageCategory = (uData.categoryPath || []).slice(-1)[0] || (categoryEl && categoryEl.value) || '';
    const refinementBar = queryFirst('.refinement-bar');
    const subCatRefinementBar = queryFirst('.subcategory-refinement-bar');
    const productGrid = queryFirst('.product-grid-container');

    let showMoreCount = 0;

    const { tealiumProdSkus, tealiumProdListName, tealiumListIds, tealiumProdNames, tealiumProdLists, tealiumProdPrices, tealiumProdOriginalPrices, tealiumProdVariants, tealiumProdBadges, tealiumProdStyles, tealiumProdColors } = window;
    $(productGrid).on('click', '.js-initiate-enrollment', () => {
        $(productGrid).trigger('ga:loyalty_initiate_enrollment');
    });

    // Product List (Chunks of 24)
    if (tealiumProdSkus) {
        const chunkSize = 24;
        const numSkus = tealiumProdSkus.length;
        const numChunks = Math.ceil(numSkus / chunkSize);
        const breadcrumbElem = queryFirst('.category-breadcrumbs');
        const breadcrumbs = breadcrumbElem && breadcrumbElem.value;
        const searchType = (uData.page_type === 'search' || uData.search_term) ? getItemFromLocalStorage('searchType') : '';
        const searchSuggestion = (uData.page_type === 'search' || uData.search_term) ? getItemFromLocalStorage('selectedSuggestion') : '';

        const buildProductListPayload = (start, end) => ({
            event_name: VIEW_ITEM_LIST,
            product_list: breadcrumbs || uData.category_name || tealiumProdListName,
            category_id: uData.category_id || '',
            search_term: decodeURI(uData.search_term) || '',
            search_type: searchType,
            search_suggestion: searchSuggestion,
            num_search_results: uData.num_search_results || '',
            product_list_id: tealiumListIds.slice(start, end),
            product_list_name: tealiumProdNames.slice(start, end),
            product_list_category: tealiumProdLists.slice(start, end),
            product_list_sku: tealiumProdSkus.slice(start, end),
            product_variant: tealiumProdVariants.slice(start, end),
            affiliation: Array.from({ length: end - start }).fill(uData.affiliation[0]),
            product_list_price: setAdjustedSalesPrice(tealiumProdStyles.slice(start, end), tealiumProdPrices.slice(start, end)),
            product_list_position: Array.from({ length: end - start }, (_, i) => start + i + 1),
            product_list_original_price: tealiumProdOriginalPrices.slice(start, end),
            product_badge: tealiumProdBadges.slice(start, end),
            product_category: Array.from({ length: end - start }).fill(uData.category_id || ''),
            product_color: tealiumProdColors.slice(start, end)
        });

        for (let c = 0; c < numChunks; c++) {
            const start = c * chunkSize;
            const end = Math.min((c + 1) * chunkSize, numSkus);
            const payload = buildProductListPayload(start, end);
            sendEventGA(payload).finally(() => {
                // store data on the last iteration
                if (c + 1 >= numChunks) storePersistentData(payload);
            });
        }
    }

    // Subcategory refine bar
    bindGA([subCatRefinementBar], (bindElement, srcElement) => {
        // Disregard filter groups
        if (hasClass(srcElement, 'title')) return false;

        let filterValueEl = hasClass(srcElement, 'subcategory-refinement-text') ? srcElement : queryFirst('.subcategory-refinement-text', srcElement);
        let filterValue = (filterValueEl && getText(filterValueEl)) || '';

        return {
            // GA4
            event_name: PLP_INTERACTION_FILTER,
            interaction_type: 'filter',
            filter_action: 'select',
            filter_group: 'refinement bar',
            filter_details: `${filterValue}`,

            // GA360
            event_category: PLP_FILTER_SELECT,
            event_action: `refinement bar:${filterValue}`,
            event_label: 'select'
        };
    }, {
        bindOptions: {
            targetSelectors: ['button']
        }
    });
    // Apply/Remove Filters
    bindGA([refinementBar], (bindElement, srcElement) => {
        // Disregard filter groups
        if (hasClass(srcElement, 'title')) return false;

        const groupEl = srcElement.closest('.refinement');
        const filterCategoryEl = queryFirst('.card-header .title', groupEl);
        let filterValueEl = hasClass(srcElement, 'refinement-text') ? srcElement : queryFirst('.refinement-text', srcElement);
        const filterCategory = (filterCategoryEl && filterCategoryEl.textContent.replace(/\s+/g, ' ').trim()) || '';
        let filterValue = (filterValueEl && getText(filterValueEl)) || '';
        const isSelected = !hasClass(srcElement, 'selected');

        if (!filterValueEl) {
            // Is this a price filter?
            filterValueEl = srcElement.closest('.price-filter-form');

            // Unsupported filter!
            if (!filterValueEl) return false;

            if (filterValueEl) {
                const minPriceEl = queryFirst('.price-filter-min', filterValueEl);
                const maxPriceEl = queryFirst('.price-filter-max', filterValueEl);
                const minPrice = (minPriceEl && minPriceEl.value) || '';
                const maxPrice = (maxPriceEl && maxPriceEl.value) || '';

                filterValue = `$${minPrice}-$${maxPrice}`;
            }
        }

        return {
            // GA4
            event_name: PLP_INTERACTION_FILTER,
            interaction_type: 'filter',
            filter_action: isSelected ? 'on' : 'off',
            filter_group: `${filterCategory}`,
            filter_details: `${filterValue}`,

            // GA360
            event_category: PLP_FILTER_SELECT,
            event_action: `${filterCategory}:${filterValue}`,
            event_label: isSelected ? 'on' : 'off'
        };
    }, {
        bindOptions: {
            targetSelectors: ['button']
        }
    });

    bindGA(refinementBar, (bindElement, srcElement) => {
        const { storeId, storeName } = srcElement.dataset;
        return {
            // GA4
            event_name: PLP_INTERACTION_FILTER,
            interaction_type: 'ispu filter toggle',
            filter_action: srcElement.checked ? 'on' : 'off',
            filter_details: [storeName, storeId],

            // GA360
            event_category: 'ispu filter toggle',
            event_action: srcElement.checked ? 'on' : 'off',
            event_label: [storeName, storeId]
        };
    }, {
        bindOptions: {
            eventType: 'change',
            targetSelectors: ['.store-filter-toggle']
        }
    });

    // Remove Applied Filter
    bindGA(productGrid, (bindElement, srcElement) => {
        const filterTextEl = queryFirst('.filter-pills-option-text', srcElement);
        const filterValue = filterTextEl.textContent;
        const { filterGroupId } = filterTextEl.dataset;
        const filterCategoryEl = queryFirst(`.refinement[data-filter-group-id="${filterGroupId}"]`);
        const filterCategory = (filterCategoryEl && queryFirst('.title', filterCategoryEl).textContent.trim()) || '';

        return {
            // GA4
            event_name: PLP_INTERACTION_FILTER,
            interaction_type: 'remove filter',
            filter_action: 'off',
            filter_group: `${filterCategory}`,
            filter_details: `${filterValue}`,

            // GA360
            event_category: PLP_SELECTIONS,
            event_action: `${filterCategory}:${filterValue}`,
            event_label: 'off'
        };
    }, {
        bindOptions: {
            targetSelectors: ['.filter-pills-option']
        }
    });

    // Clear Filters
    bindGA(body, {
        // GA4
        event_name: PLP_INTERACTION_FILTER,
        interaction_type: 'clear filters',
        filter_action: 'clear filters',

        // GA360
        event_category: PLP_SELECTIONS,
        event_action: 'clear filters'
    }, {
        bindOptions: {
            targetSelectors: ['.clear-filters-btn']
        }
    });

    // Toggle Filters Menu
    bindGA(queryFirst('.hide-filter-btn'), bindElement => {
        const isOpen = (bindElement.getAttribute('aria-expanded') === 'true');

        return {
            // GA4
            event_name: PLP_INTERACTION_FILTER,
            interaction_type: 'toggle hide/show filters',
            filter_action: `filter menu:${isOpen ? 'open' : 'close'}`,

            // GA360
            event_category: PLP_SELECTIONS,
            event_action: `filter menu:${isOpen ? 'open' : 'close'}`,
            event_label: pageCategory
        };
    }, {
        eventType: 'toggle.lp.filters'
    });

    // Toggle Filter Group
    bindGA(refinementBar, (bindElement, srcElement) => {
        const isOpen = (srcElement.getAttribute('aria-expanded') !== 'true');

        return {
            // GA4
            event_name: PLP_INTERACTION_FILTER,
            interaction_type: 'toggle filters group',
            filter_action: isOpen ? 'open' : 'close',
            filter_details: srcElement.textContent.trim(),

            // GA360
            event_category: PLP_SELECTIONS,
            event_action: 'filter group:' + srcElement.textContent.trim(),
            event_label: isOpen ? 'open' : 'close'
        };
    }, {
        bindOptions: {
            targetSelectors: ['.card-header .title']
        }
    });

    // Sort By
    bindGA(queryAll('.sort-order-menu-option'), bindElement => {
        const { optionName } = bindElement.dataset;

        return {
            // GA4
            event_name: 'plp_interaction_sort',
            interaction_type: 'sort by',
            sort_selected: optionName,

            // GA360
            event_category: PLP_SELECTIONS,
            event_action: 'sort by:' + optionName,
            event_label: pageCategory
        };
    });

    // Show More Buttons
    bindGA(productGrid, () => {
        showMoreCount++;

        return {
            event_category: PLP_MORE_RESULTS,
            event_action: `more results:${showMoreCount}`,
            event_label: pageCategory
        };
    }, {
        bindOptions: {
            targetSelectors: ['.show-more button']
        }
    });

    // Pagination Arrows
    bindGA(productGrid, (bindElement, srcElement) => {
        const pageSelector = queryFirst('.pagination-pages', productGrid);
        const currentPage = parseInt(pageSelector.value, 10) || 1;
        const totalPages = queryAll('option', pageSelector).length || currentPage;
        const type = hasClass(srcElement, 'page-previous') ? 'previous' : 'next';
        const newPage = (type === 'previous') ? currentPage - 1 : currentPage + 1;

        return {
            event_category: PLP_PAGINATION,
            event_action: `${type}|${newPage}`,
            event_label: `of ${totalPages} pages total`
        };
    }, {
        bindOptions: {
            targetSelectors: ['.page-next', '.page-previous']
        }
    });

    // Pagination Dropdown
    bindGA(productGrid, (bindElement, srcElement) => {
        const currentPage = parseInt(srcElement.value, 10) || 1;
        const totalPages = queryAll('option', srcElement).length || currentPage;

        return {
            event_category: PLP_PAGINATION,
            event_action: `page|${currentPage}`,
            event_label: `of ${totalPages} pages total`
        };
    }, {
        eventType: 'change',
        retriggerEvent: false,
        bindOptions: {
            targetSelectors: ['.pagination-pages']
        }
    });

    // More Colors Links
    bindGA(productGrid, (bindElement, srcElement) => {
        const { productName, productColor, masterId } = getProductData(srcElement);

        return {
            event_category: MORE_COLORS,
            event_action: [productName, masterId],
            event_label: productColor
        };
    }, {
        bindOptions: {
            targetSelectors: ['.swatches-more-colors']
        }
    });

    // Early Access - PLP QV Sign up for Loyalty (signed in but NOT loyalty member) join club lilly
    bindGA(productGrid, (bindElement, srcElement) => {
        const { productBadge } = getProductData(srcElement);
        return {
            //GA4
            event_name: LOYALTY_ENROLLMENT_EVENT_NAME,
            interaction_type: LOYALTY_PROGRAM_ACTION,
            product_badge: [productBadge]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.early-access-sign-up', '.lca-color-navy']
        }
    });
    bindGA(body, {
        //GA4
        event_name: LOYALTY_ENROLLMENT_EVENT_NAME,
        interaction_type: LOYALTY_PROGRAM_ACTION
    }, {
        bindOptions: {
            targetSelectors: [ENROLL_LOYALTY_CTA]
        }
    });
    // Clicking on banners with initiate ennrolment class
    bindGA(productGrid, {
        //GA4
        event_name: LOYALTY_ENROLLMENT_EVENT_NAME,
        interaction_type: LOYALTY_PROGRAM_ACTION
    }, {
        eventType: 'ga:loyalty_initiate_enrollment',
        isCustomEvent: true,
        bindOptions: {
            once: true
        }
    });

    // Shop-by-Print Specific
    if (uData.page_category === 'Prints') {
        // View All Link
        bindGA(queryAll('.view-all-btn'), {
            event_category: SHOP_BY_PRINT,
            event_action: 'view all'
        }, {
            retriggerEvent: false
        });

        // View Less Button
        bindGA(queryAll('.toggle-drawer-btn'), {
            event_category: SHOP_BY_PRINT,
            event_action: 'view less'
        }, {
            retriggerEvent: false
        });

        // Print Swatch
        bindGA(queryAll('.shop-by-print-drawer-tile'), bindElement => ({
            event_category: SHOP_BY_PRINT,
            event_action: 'print swatch click',
            event_label: queryFirst('.shop-by-print-drawer-tile-title', bindElement).textContent.trim()
        }));

        // Shop the Print QuickViews - Shop the Print Button
        bindGA(queryAll('.shop-by-print-quickview'), bindElement => ({
            event_category: SHOP_BY_PRINT,
            event_action: 'shop this print',
            event_label: queryFirst('.print-quickview-body-title', bindElement).textContent.trim()
        }), {
            bindOptions: {
                targetSelectors: ['.print-quickview-body-shop-print']
            }
        });
    }
}

initEvents();
